import { createSlice } from "@reduxjs/toolkit";
import {
  placeOrder,
  fetchMyOrders,
  cancelOrder,
  completeOrder,
  deleteOrder,
} from "./orderThunk";

const initialState = {
  orders: [],
  status: "idle",
  error: null,
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    clearOrders(state) {
      state.orders = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // -------- PLACE ORDER --------
      .addCase(placeOrder.pending, (state) => {
        state.status = "loading";
      })
      .addCase(placeOrder.fulfilled, (state, action) => {
        state.status = "success";
        state.orders.unshift(action.payload);
      })
      .addCase(placeOrder.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      })

      // -------- FETCH MY ORDERS --------
      .addCase(fetchMyOrders.fulfilled, (state, action) => {
        state.status = "success";
        state.orders = action.payload;
      })

      // -------- CANCEL ORDER --------
      .addCase(cancelOrder.fulfilled, (state, action) => {
        const idx = state.orders.findIndex((o) => o._id === action.payload._id);
        if (idx !== -1) state.orders[idx] = action.payload;
      })

      // -------- COMPLETE ORDER --------
      .addCase(completeOrder.fulfilled, (state, action) => {
        const idx = state.orders.findIndex((o) => o._id === action.payload._id);
        if (idx !== -1) state.orders[idx] = action.payload;
      })

      // -------- DELETE ORDER --------
      .addCase(deleteOrder.fulfilled, (state, action) => {
        state.orders = state.orders.filter((o) => o._id !== action.meta.arg);
      });
  },
});

export const { clearOrders } = orderSlice.actions;
export default orderSlice.reducer;
